// extracted by mini-css-extract-plugin
module.exports = {"Input":"Input_Input__3YZVR","LocationIcon":"Input_LocationIcon__1PSIU","numberButton":"Input_numberButton__3L8wU","option":"Input_option__3YqnC"};